//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectIReferenceAxis.js";
import "../no/Plane.js";
import "../no/SelectISurface.js";
import "../no/Sketch.js";
import "../no/type.js";
import "../no/SelectObject.js";
let d=[[[1,"Axis",0,"SelectIReferenceAxis",1],[0,"AxisOrientation",1,0],[0,"AxisOrientationInfer",1,0],[0,"AxisReference",1,"Direction",0],[0,"CreateIntermediateDatumCsys",1,1],[0,"Csystem",1,"CartesianCoordinateSystem",0],[0,"MakeOriginAssociative",1,1],[0,"OriginOption",1,0],[0,"OriginOptionInfer",1,0],[1,"Plane",0,"Plane",1],[0,"PlaneOption",1,0],[1,"PlaneOrFace",0,"SelectISurface",1],[0,"PlaneReference",1,"Plane",0],[0,"ProjectWorkPartOrigin",1,1],[0,"ReverseAxis",1,1],[0,"ReversePlaneNormal",1,1],[0,"SketchOrigin",1,"Point",0]],[],[]];
SPLM.SketchInPlaceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchInPlaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;